<template>
  <div class="bp-collapse" :class="{ open }">
    <button class="bp-collapse-header p-5 p-lg-4" @click="open = !open">
      <i :icon="icon" v-if="icon" />

      <div class="bp-collapse-header-title px-5">{{ title }}</div>
      <bp-icon icon="fa-light fa-chevron-up" class="arrow-icon" />
    </button>

    <div class="bp-collapse-body">
      <div class="bp-collapse-inner">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      open: false
    };
  }
};
</script>

<style lang="scss" scoped>
.bp-collapse {
  border-top: 1px solid transparent;
  border-bottom: 1px solid $neutral-300;
  transition: border-color 0.3s, background-color 0.3s;

  .bp-collapse-header {
    width: 100%;
    border: none;
    display: flex;
    text-align: unset;
    align-items: center;
    background-color: transparent;
    justify-content: space-between;
    color: $neutral-500;
    .bp-collapse-header-title {
      color: $neutral-600;
    }
    .arrow-icon {
      transform: rotate(0);
      transition: 0.3s transform;
    }
  }

  .bp-collapse-body {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.3s;

    .bp-collapse-inner {
      padding: 0 16px;
      transition: 0.3s padding;
      overflow: hidden;
    }
  }

  &.open {
    border-color: $primary-400;
    background-color: rgba(255, 255, 255, 0.8);
    .bp-collapse-header {
      color: $primary-600;
      .bp-collapse-header-title {
        color: $primary-700;
      }
      .arrow-icon {
        transform: rotate(180deg);
      }
    }

    .bp-collapse-body {
      grid-template-rows: 1fr;
      .bp-collapse-inner {
        padding: 0 16px 16px;
      }
    }
  }
}
</style>
